"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TollRateCalculator = void 0;
const map_1 = __importDefault(require("lodash/map"));
const filter_1 = __importDefault(require("lodash/filter"));
const find_1 = __importDefault(require("lodash/find"));
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_select_1 = __importStar(require("react-select"));
const data_1 = require("./data");
const calculateTollRates_1 = require("./calculateTollRates");
function useSelect(optionsData, initialHidden, initialError) {
    const [currentOption, setCurrentOption] = react_1.useState(null);
    const [hidden, setHidden] = react_1.useState(initialHidden !== undefined ? initialHidden : false);
    const [error, setError] = react_1.useState(initialError !== undefined ? initialError : false);
    const onChangeHandler = react_1.useCallback((valueType, actionMeta) => {
        if (!valueType) {
            return;
        }
        if ('value' in valueType && 'label' in valueType) {
            setCurrentOption(valueType);
        }
        setError(false);
    }, [setCurrentOption, setError]);
    return [
        currentOption,
        setCurrentOption,
        onChangeHandler,
        hidden,
        setHidden,
        error,
        setError
    ];
}
function getPoints(pointIDs) {
    return filter_1.default(map_1.default(pointIDs, (entryPointID) => find_1.default(data_1.points, { value: entryPointID })), entrypoint => entrypoint !== undefined);
}
function getExitpoint(tollFacility, entrypoint) {
    const empty = [];
    if (!entrypoint) {
        return empty;
    }
    const entryexitpoint = find_1.default(data_1.entrypointExitPointMap[tollFacility], { entrypoint });
    if (!entryexitpoint) {
        return empty;
    }
    const entrypointID = entryexitpoint.exitpoints;
    return getPoints(entrypointID);
}
function TollRateCalculator() {
    var _a;
    const [tollRateInfo, setTollRateInfo] = react_1.useState(null);
    const [footnotes, setFootnotes] = react_1.useState({
        showIccInfo: false,
        showUS40Info: false,
        showBybInfo: false,
        showCovidInfo: false,
        showAxleInfo: false,
        showEtlInfo: false,
    });
    const [vehicleType] = react_1.useState(data_1.vehicleTypeData);
    const [currentVehicleType, setCurrentVehicleType, vehicleTypeChangeHandler, , , vehicleTypeError, setVehicleTypeError] = useSelect(vehicleType);
    const [tollFacility] = react_1.useState(data_1.tollFacilityData);
    const [currentTollFacility, setCurrentTollFacility, tollFacilityChangeHandler, , , tollFacilityError, setTollFacilityError] = useSelect(tollFacility);
    const [currentEntrypoint, setCurrentEntrypoint, entrypointChangeHandler, entrypointHidden, setEntrypointHidden, entrypointError, setEntrypointError,] = useSelect(getPoints(data_1.entrypointData['icc']));
    const [exitpoint, setExitPoint] = react_1.useState([]);
    const [currentExitpoint, setCurrentExitpoint, exitpointChangeHandler, exitpointHidden, setExitpointHidden, exitpointError, setExitpointError] = useSelect(exitpoint);
    const [currentBhtSubOption, setCurrentBhtSubOption, bhtSubOptionChangeHandler, bhtSubOptionHidden, setBhtSubOptionHidden, bhtSubOptionError, setBhtSubOptionError,] = useSelect(data_1.bhtSubOptions, true);
    const [submitted, setSubmitted] = react_1.useState(false);
    react_1.useEffect(() => {
        if (currentTollFacility && currentTollFacility.value === 'icc' || currentTollFacility && currentTollFacility.value === 'etl') {
            setEntrypointHidden(false);
            setExitpointHidden(false);
        }
        else {
            setEntrypointHidden(true);
            setExitpointHidden(true);
            setCurrentEntrypoint(null);
            setCurrentExitpoint(null);
        }
    }, [currentTollFacility, setEntrypointHidden, setExitpointHidden, setCurrentEntrypoint, setCurrentExitpoint]);
    react_1.useEffect(() => {
        if (currentTollFacility && currentTollFacility.value === 'bht') {
            setBhtSubOptionHidden(false);
        }
        else {
            setBhtSubOptionHidden(true);
            setCurrentBhtSubOption(null);
        }
    }, [currentTollFacility, setBhtSubOptionHidden, setCurrentBhtSubOption]);
    react_1.useEffect(() => {
        var _a;
        const entry = currentEntrypoint ? currentEntrypoint.value : undefined;
        setExitPoint(getExitpoint((_a = currentTollFacility === null || currentTollFacility === void 0 ? void 0 : currentTollFacility.value) !== null && _a !== void 0 ? _a : 'icc', entry));
        setCurrentExitpoint(null);
    }, [currentEntrypoint, setExitPoint, setCurrentExitpoint]);
    const validateData = react_1.useCallback(() => {
        let success = true;
        if (!currentVehicleType) {
            setVehicleTypeError(true);
            success = false;
        }
        if (!currentTollFacility) {
            setTollFacilityError(true);
            success = false;
        }
        if (currentTollFacility && currentTollFacility.value === 'icc') {
            if (!currentEntrypoint) {
                setEntrypointError(true);
                success = false;
            }
            if (!currentExitpoint) {
                setExitpointError(true);
                success = false;
            }
        }
        if (currentTollFacility && currentTollFacility.value === 'bht') {
            if (!currentBhtSubOption) {
                setBhtSubOptionError(true);
                success = false;
            }
        }
        return success;
    }, [
        currentVehicleType,
        setVehicleTypeError,
        currentTollFacility,
        setTollFacilityError,
        currentEntrypoint,
        setEntrypointError,
        currentExitpoint,
        setExitpointError,
        currentBhtSubOption,
        setBhtSubOptionError
    ]);
    const submitHandler = react_1.useCallback((event) => {
        event.preventDefault();
        if (!validateData()) {
            return;
        }
        const vehicleType = currentVehicleType.value;
        const selectedFacility = currentTollFacility.value;
        const effectiveTollFacility = selectedFacility === 'bht' && currentBhtSubOption
            ? currentBhtSubOption.value
            : selectedFacility;
        const entrypoint = currentEntrypoint ? currentEntrypoint.value : undefined;
        const exitpoint = currentExitpoint ? currentExitpoint.value : undefined;
        console.log(vehicleType, effectiveTollFacility, entrypoint, exitpoint);
        setTollRateInfo(calculateTollRates_1.calculateTollRates(vehicleType, effectiveTollFacility, entrypoint, exitpoint));
        setFootnotes({
            showIccInfo: effectiveTollFacility === 'icc' || effectiveTollFacility === 'etl',
            showUS40Info: (vehicleType === 'class2' || vehicleType === 'class8') && effectiveTollFacility === 'tjh',
            showBybInfo: (vehicleType === 'class2' || vehicleType === 'class8') && effectiveTollFacility === 'byb',
            showCovidInfo: ['jfk', 'byb', 'nmb', 'fmt', 'bht', 'bht-ramps'].includes(effectiveTollFacility || ''),
            showAxleInfo: ['class3', 'class4', 'class5', 'class6'].includes(vehicleType || '') && effectiveTollFacility === 'fsk',
            showEtlInfo: effectiveTollFacility === 'etl'
        });
        setSubmitted(true);
    }, [
        validateData,
        currentVehicleType,
        currentTollFacility,
        currentBhtSubOption,
        currentEntrypoint,
        currentExitpoint,
        setTollRateInfo,
        setFootnotes,
        setSubmitted
    ]);
    return (react_1.default.createElement("div", { className: 'toll-rate-calculator-wrapper' },
        react_1.default.createElement("form", { className: 'form toll-rate-calculator', onSubmit: submitHandler },
            react_1.default.createElement(SelectField, { label: 'Step 1 - Choose Vehicle Type', htmlFor: 'vehicle_type', name: 'vehicle_type', placeholder: 'Select Vehicle Type', options: vehicleType, currentOption: currentVehicleType, onChange: vehicleTypeChangeHandler, invalid: vehicleTypeError }),
            react_1.default.createElement(SelectField, { label: 'Step 2 - Choose Toll Facility', htmlFor: 'toll_facility', name: 'toll_facility', placeholder: 'Select Toll Facility', options: tollFacility, currentOption: currentTollFacility, onChange: tollFacilityChangeHandler, invalid: tollFacilityError }),
            react_1.default.createElement(SelectField, { label: 'Step 3 - Choose Tunnel Access', htmlFor: 'bht_sub_option', name: 'bht_sub_option', placeholder: 'Select Tunnel Access', options: data_1.bhtSubOptions, currentOption: currentBhtSubOption, onChange: bhtSubOptionChangeHandler, hidden: bhtSubOptionHidden, invalid: bhtSubOptionError }),
            react_1.default.createElement(SelectField, { label: 'Step 3 - Choose Entry Point', htmlFor: 'entry_point', name: 'entry_point', placeholder: 'Select Entry Point', options: getPoints(data_1.entrypointData[(_a = currentTollFacility === null || currentTollFacility === void 0 ? void 0 : currentTollFacility.value) !== null && _a !== void 0 ? _a : 'icc']), currentOption: currentEntrypoint, onChange: entrypointChangeHandler, hidden: entrypointHidden, invalid: entrypointError }),
            react_1.default.createElement(SelectField, { label: 'Step 4 - Choose Exit Point', htmlFor: 'exit_point', name: 'exit_point', placeholder: 'Select Exit Point', options: exitpoint, currentOption: currentExitpoint, onChange: exitpointChangeHandler, hidden: exitpointHidden, invalid: exitpointError }),
            react_1.default.createElement("div", { className: "form_item" },
                react_1.default.createElement("input", { type: "submit", value: 'View Toll Rates' })),
            submitted ? react_1.default.createElement(TollRateResults, { tollRateInfo: tollRateInfo, footnotes: footnotes }) : null)));
}
exports.TollRateCalculator = TollRateCalculator;
function SelectField(props) {
    const { label, htmlFor, name, placeholder, options, currentOption, onChange } = props;
    const hidden = props.hidden !== undefined ? props.hidden : false;
    const invalid = props.invalid !== undefined ? props.invalid : false;
    const IndicatorSeparator = () => null;
    const DropdownIndicator = (props) => {
        return (react_1.default.createElement(react_select_1.components.DropdownIndicator, Object.assign({}, props),
            react_1.default.createElement("span", { className: 'dropdownIndicator' })));
    };
    const Option = (props) => {
        return (react_1.default.createElement(react_select_1.components.Option, Object.assign({}, props),
            props.data.img ? react_1.default.createElement("img", { src: props.data.img, alt: props.data.label, className: 'form_select_img_option' }) : null,
            props.data.label));
    };
    const customStyle = {
        control: () => ({
            border: 'none'
        }),
        menuList: () => ({
            maxHeight: '400px'
        })
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('form_item', 'underlined', { hidden }, { invalid }) },
        react_1.default.createElement("label", { htmlFor: htmlFor, className: 'form_label' }, label),
        currentOption && currentOption.img ? react_1.default.createElement("img", { className: 'form_select_img_indicator', src: currentOption.img, alt: currentOption.label }) : null,
        react_1.default.createElement(react_select_1.default, { className: 'form_select', classNamePrefix: 'form_select', name: name, placeholder: placeholder, value: currentOption, onChange: onChange, options: options, components: { IndicatorSeparator, DropdownIndicator, Option }, styles: customStyle })));
}
function TollRateResults(props) {
    const { tollRateInfo, footnotes } = props;
    const renderPrice = react_1.useCallback((quantity) => {
        const filteredQuantity = quantity.replace(/\*/g, '');
        const numericQuantity = Number(filteredQuantity);
        if (isNaN(numericQuantity)) {
            return 'N/A';
        }
        return '$' + numericQuantity.toFixed(2) + (quantity.includes('*') ? ' **' : '');
    }, []);
    const renderHeader = react_1.useCallback((header) => {
        return header.replace(/-/g, '\u2011');
    }, []);
    const renderRateName = react_1.useCallback((rateName) => {
        return rateName.replace(/E-ZPass/g, '<i>E-ZPass</i>');
    }, []);
    if (!tollRateInfo) {
        return react_1.default.createElement("div", { className: 'toll-rate-results' }, "No results found");
    }
    const { headers, rates, savings } = tollRateInfo;
    return (react_1.default.createElement("div", { className: 'toll-rate-results' },
        react_1.default.createElement("div", { className: 'table-wrapper' },
            react_1.default.createElement("table", null,
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null),
                        react_1.default.createElement("th", null),
                        map_1.default(headers, (header, index) => react_1.default.createElement("th", { key: index }, renderHeader(header))))),
                react_1.default.createElement("tbody", null,
                    map_1.default(rates, (rate, index) => {
                        return (react_1.default.createElement("tr", { key: index },
                            react_1.default.createElement("td", { className: classnames_1.default({ 'last_row': index === rates.length - 1 }) },
                                react_1.default.createElement("img", { src: find_1.default(data_1.rateNamesImgs, { name: rate.name }).img, alt: rate.name })),
                            react_1.default.createElement("td", { className: 'rate_name', dangerouslySetInnerHTML: { __html: renderRateName(rate.name) } }),
                            map_1.default(rate.values, (value, value_index) => react_1.default.createElement("td", { key: value_index, className: 'rate_price' }, renderPrice(value)))));
                    }),
                    react_1.default.createElement("tr", { className: 'savings' },
                        react_1.default.createElement("td", { colSpan: 2 }, "Possible Savings*"),
                        map_1.default(savings, (saving, index) => react_1.default.createElement("td", { key: index, className: 'value' }, renderPrice(saving))))))),
        react_1.default.createElement(FootNote, { footnotes: footnotes })));
}
function FootNote({ footnotes }) {
    const { showIccInfo, showUS40Info, showBybInfo, showCovidInfo, showAxleInfo, showEtlInfo } = footnotes;
    return (react_1.default.createElement("div", { className: 'footnote' },
        react_1.default.createElement("p", { className: 'firstNote separation' },
            "*Savings reflect ",
            react_1.default.createElement("i", null, "E-ZPass"),
            " MD Toll vs Video Toll."),
        showIccInfo ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "** Pricing periods are peak, off-peak, and overnight:"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "Peak"),
                    " (Mon - Fri, 6 - 9am; 4 - 7pm) excluding most Federal Holidays",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("b", null, "Off-Peak"),
                    " (Mon - Fri, 5 - 6am; 9am -4pm; 7 - 11pm; Sat & Sun 5am - 11pm)",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("b", null, "Overnight"),
                    " (11pm - 5am Daily)"),
                react_1.default.createElement("p", null,
                    "*** Video Toll Rates (VTR) are 1.5 times the ",
                    react_1.default.createElement("i", null, "E-ZPass"),
                    " toll rates with a minimum of $1/maximum of $15 above the ",
                    react_1.default.createElement("i", null, "E-ZPass"),
                    " rates.",
                    react_1.default.createElement("br", null),
                    "**** Note: Weekends and most Federal holidays. Off-Peak (5am - 11pm)")))
            : null,
        showUS40Info ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "separation" },
                    "\u271D For customers with Hatem A or B Plans, crossing the Hatem Bridge would result in a $0 toll. See ",
                    react_1.default.createElement("a", { href: "/acct-types/e-zpass-discount-plans/", target: "_blank" }, "plan descriptions"),
                    " for more information.")))
            : null,
        showBybInfo ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "separation" },
                    "** The WPL Bay Bridge Shopper's Plan is $2 per trip. For details visit ",
                    react_1.default.createElement("a", { href: "/acct-types/e-zpass-discount-plans/", target: "_blank" }, "discount plans"),
                    ".")))
            : null,
        showEtlInfo ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "separation" },
                    "** Video Toll Rates (VTR) are 1.5 times the ",
                    react_1.default.createElement("i", null, "E-ZPass"),
                    " toll rates with a minimum of $1/maximum of $15 above the ",
                    react_1.default.createElement("i", null, "E-ZPass"),
                    " rates.",
                    react_1.default.createElement("br", null),
                    "*** Pricing periods are peak, off-peak, and overnight",
                    react_1.default.createElement("br", null),
                    "NOTE: Holiday Rates apply and are available at ",
                    react_1.default.createElement("a", { href: "http://www.mdta.maryland.gov/ETL/Toll_Rate_Schedule.html", target: "_blank" }, "http://www.mdta.maryland.gov/ETL/Toll_Rate_Schedule.html")),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "ETL Northbound Peak"),
                    " (Mon - Fri, 3 - 7pm; Sat, 12 - 2pm; Sun, 2 - 5pm)",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("b", null, "ETL Southbound Peak"),
                    " (Mon - Fri, 6 - 9am; Sat, 12 - 2pm; Sun, 2 - 5pm)"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "ETL Northbound Off-Peak"),
                    " (Mon - Fri, 5am - 3pm; 7 - 9pm; Sat, 5am - 12pm, 2 - 9pm; Sun 5am - 2pm, 5 - 9pm)",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("b", null, "ETL Southbound Off-Peak"),
                    " (Mon - Fri, 5 - 6am; 9am - 9pm; Sat, 5am - 12pm, 2 - 9pm; Sun 5am - 2pm, 5 - 9pm)"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "ETL Northbound Overnight"),
                    " (9pm - 5am Daily)",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("b", null, "ETL Southbound Overnight"),
                    " (9pm - 5am Daily)")))
            : null,
        showAxleInfo ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: 'separation' },
                    "**Commercial-vehicle drivers with a valid ",
                    react_1.default.createElement("i", null, "E-ZPass"),
                    " Maryland account and transponder pay $2 per axle for 3, 4, 5 and 6+ axle vehicles to use the I-895/Childs Street ramps at the Baltimore Harbor Tunnel or the I-695/Broening Highway turnaround at the Francis Scott Key Bridge.")))
            : null,
        showCovidInfo ?
            (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "separation" }, "Note: Video Toll transactions at this facility between March 17, 2020, and December 31, 2020, were adjusted to the former cash toll rate to help provide financial relief to our customers during the COVID-19 pandemic. The former cash rate is the same as the Pay-By-Plate rate represented on the calculator.")))
            : null));
}
